<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id" v-if="shops.length > 0">
                <el-select
                    v-model="queryForm.shop_id"
                    filterable
                    remote
                    clearable
                    :remote-method="remoteShopMethod"
                    placeholder="请输入店铺">
                    <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--            <el-form-item label="配送类型" prop="orderType">-->
            <!--                <el-select v-model="queryForm.orderType" placeholder="请选择">-->
            <!--                    <el-option label="外卖配送" value="0"></el-option>-->
            <!--                    <el-option label="打包自提" value="1"></el-option>-->
            <!--                    <el-option label="堂食" value="3"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="" prop="dateType">
                <el-select v-model="queryForm.dateType" placeholder="请选择" class="fl">
                    <el-option label="下单日期" value="1"></el-option>
                    <el-option label="送达日期" value="2"></el-option>
                </el-select>
                <el-date-picker
                    class="fl ml10"
                    v-model="queryForm.dateRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="订单号" prop="orderId">
                <el-input type="text" v-model="queryForm.orderId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="支付方式" prop="payway">
                <el-select v-model="queryForm.payway" placeholder="请选择">
                    <el-option label="微信" value="1"></el-option>
                    <el-option label="支付宝" value="2"></el-option>
                    <el-option label="银联" value="3"></el-option>
                    <el-option label="校园卡" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20" v-if="affiliation_level == 1 || affiliation_level == 2">
            <export-excel :params="exportParams" :action="$apiUrl.financeTransactionBill" :target="'oc'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>
        <el-tabs v-model="queryForm.orderStatus" @tab-click="getTableData">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="已支付" name="1001"></el-tab-pane>
            <el-tab-pane label="已完成" name="2002"></el-tab-pane>
            <el-tab-pane label="已取消" name="9000"></el-tab-pane>
        </el-tabs>
        <!--table-->
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="supplierShortName"
                label="店铺名称"
                :show-overflow-tooltip="true"
                width="160">
            </el-table-column>
            <el-table-column
                prop="id"
                label="订单号"
                width="180">
            </el-table-column>
            <el-table-column
                prop="costAmount"
                label="支付金额"
                width="120">
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="commissionRate"-->
            <!--                    label="佣金率"-->
            <!--                    width="120">-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                    prop="commission"-->
            <!--                    label="佣金(元)"-->
            <!--                    width="120">-->
            <!--            </el-table-column>-->
            <!--<el-table-column-->
            <!--prop="deliveryFee"-->
            <!--label="配送费(元)"-->
            <!--width="120">-->
            <!--</el-table-column>-->
            <!--            <el-table-column-->
            <!--                    prop="serviceFee"-->
            <!--                    label="服务费(元)"-->
            <!--                    width="120">-->
            <!--            </el-table-column>-->
            <!--<el-table-column-->
            <!--prop="packingFee"-->
            <!--label="环保费(元)"-->
            <!--width="120">-->
            <!--</el-table-column>-->
            <el-table-column
                prop="paywayStr"
                label="支付方式"
                width="80">
            </el-table-column>
            <el-table-column
                prop="statusCreateTime"
                label="下单时间"
                width="170">
                <!--<template slot-scope="scope">-->
                <!--<span>{{$utils.formatDate(scope.row.statusCreateTime)}}</span>-->
                <!--</template>-->
            </el-table-column>
            <el-table-column
                prop="deliveryTime"
                label="送达时间"
                width="170">
            </el-table-column>
            <el-table-column
                    prop="orderTypeStr"
                    label="配送类型"
                    width="120">
            </el-table-column>
            <el-table-column
                prop="orderStatus"
                label="订单状态"
                :show-overflow-tooltip="true"
                width="">
                <!--<template slot-scope="scope">-->
                <!--<span v-if="scope.row.orderStatus==1001">已支付</span>-->
                <!--<span v-if="scope.row.orderStatus==2002">配送完成</span>-->
                <!--<span v-if="scope.row.orderStatus==3001">确认收货</span>-->
                <!--<span v-if="scope.row.orderStatus==9000">已取消</span>-->
                <!--</template>-->
            </el-table-column>
            <el-table-column
                prop=""
                label="操作"
                fixed="right"
                width="120">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="viewDetail(scope.row)">查看</el-button>
                    <el-button size="mini" type="text" @click="viewRecord(scope.row)">配送日志</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <!--        <el-pagination-->
        <!--                @size-change="handleSizeChange"-->
        <!--                @current-change="handleCurrentChange"-->
        <!--                :current-page="queryForm.pageNo"-->
        <!--                :page-sizes="pageSizes"-->
        <!--                :page-size="queryForm.pageSize"-->
        <!--                layout="total, sizes, prev, pager, next"-->
        <!--                :total="total">-->
        <!--        </el-pagination>-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            prev-text="上一页"
            next-text="下一页"
            layout="prev, next">
        </el-pagination>

        <!--明细-->
        <el-dialog title="交易明细" :visible.sync="dialogTableVisible">
            <el-table :data="gridData">
                <el-table-column property="title" label="商品名称" width="150"></el-table-column>
                <el-table-column property="costPrice" label="供货价(元)" width="150"></el-table-column>
                <el-table-column property="number" label="数量" width="120"></el-table-column>
                <el-table-column property="commission" label="佣金(元)" width="140"></el-table-column>
                <el-table-column property="costAmount" label="供货总价(元)" width=""></el-table-column>
            </el-table>
        </el-dialog>

        <!--进程状态-->
        <el-dialog title="进程状态" :visible.sync="recordVisible">
            <el-card class="box-card mb15" v-for="r in recordDetail" :key="r.executionTime">
                <p class="bold">{{r.progressInfo}}</p>
                <p>{{r.handlers}} {{r.handlersTel}}</p>
                <p>{{$utils.formatDate(r.executionTime)}}</p>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import ExportExcel from "../../components/exportExcel2.vue"
export default {
    components: {ExportExcel},
    data() {
        return {
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            queryForm: {//查询表单数据
                pageSize: 10,
                pageNo: 1,
                startDate: '',
                endDate: '',
                dateRange: [],
                orderId: '',
                orderStatus: '0',
                // commercial_id: '',
                shop_id: '',
                orderType: '',
                dateType: '1',
                payway: '',
                for_report: true
            },

            tableData: [],//表格数据
            total: 0,//总数
            pageSizes: [10,20,30,40,50],//自定义分页条数
            multipleSelection: [],//table选中项
            loading: true,//表格是否显示加载效果

            commercials: [],
            shops: [],
            shopList: [],
            summary: {},
            affiliation_level: 0, //1,2级别可以下载数据 3不可以

            //导出
            exportParams: {},
            fileName: '订单数据表',
            fieldName: ['店铺名称','订单号','支付金额','支付方式','下单时间','送达时间','配送类型','订单状态'],
            field: ['supplierShortName','id','costAmount','paywayStr','statusCreateTime','deliveryTime','orderTypeStr','orderStatus'],
            dialogTableVisible: false,
            gridData: [],

            recordVisible: false,
            recordDetail: {}
        }
    },
    created(){
        //默认显示最近一周
        // console.log(this.$route.query)
        if(this.$route.params.date){
            // console.log(this.$route.params.date)
            let temp = [];
            temp = this.$route.params.date.split('-');
            this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
        }else{
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
        }
        this.commercials = JSON.parse(localStorage.getItem('commercials'));
        this.shops = JSON.parse(localStorage.getItem('shops'));
        if(this.$route.params.id){
            this.shopList = this.shops;
            this.queryForm.shop_id = this.$route.params.id.toString();
        }
        this.affiliation_level = JSON.parse(localStorage.getItem('accountInfo')).affiliation_level;
        this.fetchData();
    },
    methods: {
        downLoadHistoryData() {
            this.$router.push({path:`/report/history/data/${this.$route.params.ruleId}`})
        },
        //抓取列表数据
        fetchData() {
            // let range = this.queryForm.dateRange[1] - this.queryForm.dateRange[0];
            // if(range > 7*24*3600*1000){
            //     return this.$message.warning('最多只能查询一周的数据');
            // }
            this.getSummary();
            this.getTableData();
        },
        getParams() {
            let params = {...this.queryForm};
            params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
            params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
            delete params.dateRange;
            if(params.orderStatus == '0'){
                params.orderStatus = '';
            }
            return params;
        },
        getSummary() {
            let params = this.getParams();
            delete params.pageSize;
            delete params.pageNo;
            this.$apiJava.post(this.$apiUrl.financeTransactionBillSummary,params,(res)=>{
                this.summary = res.data;
            },null,'oc')
            // this.$apiJava.post(this.$apiUrl.financeTransactionBillTotal,params,(res)=>{
            //     this.total = res.data.total;
            // },null,'oc')
        },
        getTableData() {
            let params = this.getParams();
            this.exportParams = {...params};
            this.exportParams.pageNo = 1;
            this.exportParams.pageSize = 99999;

            this.$apiJava.post(this.$apiUrl.financeTransactionBill,params,(res)=>{
                this.loading = false;
                // this.total = res.data.total || 0;
                this.tableData = res.data.list || [];
            },(res)=>{
                this.$message.warning(res.message);
                this.loading = false;
                this.tableData = [];
            },'oc')
        },
        getShopList() {
            this.queryForm.shop_id = '';
            this.shopList = [];
            this.$api.get(this.$apiUrl.getShopList,{commercial_id: this.queryForm.commercial_id,page: 1,pageSize: 50},(res)=>{
                if(res.data){
                    for(let k in res.data){
                        this.shopList.push({id:k,name:res.data[k].shop_name});
                    }
                }else {
                    this.shopList = [];
                }
            })
        },
        //查看详情
        viewDetail(item) {
            this.dialogTableVisible = true;
            this.$apiJava.get(this.$apiUrl.financeTransactionBillDetail,{orderId:item.id},(res)=>{
                this.gridData = res.data.goodsList || [];
            },null,'oc')
        },
        remoteShopMethod(query){
            if (query !== '') {
                this.shopList = [];
                var arr = [];
                let len = this.shops.length;
                var reg = new RegExp(query);
                for(var i=0;i<len;i++){
                    //如果字符串中不包含目标字符会返回-1
                    if(this.shops[i].name.match(reg)){
                        this.shopList.push(this.shops[i]);
                    }
                }
            } else {
                this.shopList = [];
            }
        },
        //表单重置 item上需要添加prop属性
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = 10;
            this.shopList = [];
            this.queryForm.shop_id = '';
            if(this.$route.query.date){
                let temp = [];
                temp = this.$route.query.date.split('-');
                this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
            }else{
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.queryForm.dateRange = [day,new Date()];
            }
            //this.queryForm.dateRange = [];
        },
        //切换每页显示条数操作
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.getTableData();
        },
        //切换页码操作
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.getTableData();
        },
        //查看记录
        viewRecord(item) {
            let params = {
                transportCode: item.id,
                isOrderId: 1
            }
            this.$apiJava.get(this.$apiUrl.transportTurnOverDetail,params,(res)=>{
                if(res.data && res.data.length > 0){
                    for(let v of res.data){
                        if(v.progressInfo.indexOf('西游侠') > -1){
                            v.progressInfo = v.progressInfo.replaceAll('西游侠','骑手');
                        }
                    }
                    this.recordDetail = res.data;
                    this.recordVisible = true;
                }else{
                    this.$message.warning('该订单无配送日志');
                }
            },(res)=>{
                this.$message.warning(res.msg);
            },'transport')
        },
    }
}
</script>
<style lang="scss"  scoped>
.el-card{
    /*border: none;*/
    /*box-shadow: none;*/
}
</style>



// WEBPACK FOOTER //
// orderData.vue?24f454ac